import {Asset} from '../services/assets/assetsTypes';

export default function determineDeviceQuantityText(currentAsset: Asset | null): string {
  if (currentAsset == null) {
    return '0 device';
  }
  return `${currentAsset?.device_quantity} ${currentAsset?.device_quantity === 1 ? 'device' : 'devices'}`
}
